import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AiChatStandaloneComponent } from './ai-chat-standalone/ai-chat-standalone.component';
import { AiChatService } from './ai-chat.service';
import { Nl2brPipe } from './pipes/nl2br.pipe';
import { AiChatTabComponent } from './ai-chat-tab/ai-chat-tab.component';
import { AiChatWindowComponent } from './ai-chat-window/ai-chat-window.component';
import { AiChatWidgetComponent } from './ai-chat-widget/ai-chat-widget.component';

const routes = [
  {
    path: '',
    component: AiChatStandaloneComponent
  }
];

@NgModule({
  declarations: [
  AiChatStandaloneComponent,
  Nl2brPipe,
  AiChatTabComponent,
  AiChatWindowComponent,
  AiChatWidgetComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forChild(routes)
  ],
  providers: [
    AiChatService
  ],
  exports: [
  AiChatStandaloneComponent,
  AiChatWidgetComponent,
  AiChatTabComponent,
  AiChatWindowComponent
  ]
})
export class AiChatModule { }